export const listKnowledgebaseOverridesConfig = () => ({
  url: `/v2/knowledge_base_overrides`,
});

export const getKnowledgebaseOverridesConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base_overrides/${knowledgebaseId}`,
});

export const createKnowledgebaseOverridesConfig = () => ({
  url: `/v2/knowledge_base_overrides`,
});

export const updateKnowledgebaseOverridesConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base_overrides/${knowledgebaseId}`,
});

export const deleteKnowledgebaseOverridesConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base_overrides/${knowledgebaseId}`,
});
